<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <div class="md-layout">
        <div class="md-layout-item md-size-30 md-small-size-100">
          <validation-field name="class name" type="autocomplete">
            <isis-autocomplete
              v-model="studentData.displayValue"
              :value.sync="studentData.value"
              :options="testNameopts"
              :delayTime="500"
              :refetchOptions="
                queryObj =>
                  studentData.refetchOptions(studentData.displayValue, queryObj)
              "
              :fields="studentData.fields"
              :label="studentData.label"
              fetchOnOpen
            />
          </validation-field>
        </div>
        <div class="md-layout-item md-size-30 md-small-size-100">
          <md-button @click="getInfoIelts" class="md-info mr-6">
            {{ $t("common.search") }}
          </md-button>
        </div>
      </div>
      <md-card v-if="isSearching && studentData.value">
        <md-card-header class="md-card-header-text md-card-header-green pl-2">
          <div class="card-text">
            <p class="title text-lg">
              {{ $t("assignment_overall.ielts_overall") }}
            </p>
          </div>
        </md-card-header>
        <div>
          <div class="pl-2">
            <ielts-overall :pieChartData="pieChartData"></ielts-overall>
          </div>
          <div class="pl-2 md-layout-item md-size-100">
            <ielts-component-score
              ref="componentScoreRef"
            ></ielts-component-score>
          </div>
          <div class="md-layout-item md-size-100">
            <table-top-bottom
              :data="data"
              :pagination="pagination"
              :action-search="buttonSearch"
              @changeTopbottom="changeTopBottom($event)"
            ></table-top-bottom>
          </div>
        </div>
      </md-card>
      <div v-else class="md-layout pb-10">
        <div class="md-layout-item md-empty-page">
          <student-image class="student-image w-full"></student-image>
          <div class="text-center">
            <h2 class="font-[700] text-[26px]">
              {{ $t("assignment_overall.get_report") }}
            </h2>
            <p>
              {{
                $t("assignment_overall.please_select_test_name_to_view_report")
              }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import tableTopBottom from "./Component/tableTopBottom";
import { service_names } from "@/constants/Services";
import IeltsComponentScore from "./Component/IeltsComponentScore";
import IeltsOverall from "./Component/IeltsOverall";
import StudentImage from "@/components/Base/Illustration/Student";
import { convertDateFromServer } from "../../../helpers/datetime-helper";

export default {
  components: {
    tableTopBottom,
    IeltsOverall,
    IeltsComponentScore,
    StudentImage
  },
  data() {
    return {
      isSearching: false,
      pagination: {
        ...{
          perPage: 20,
          from: 0,
          to: 0,
          total: 0,
          currentPage: 1,
          hidePaging: false,
          hidePerPageOptions: false
        },
        ...this.paginationCfg
      },
      paramsTopBottom: {
        page: 1,
        limit: 20,
        order_by: "overall desc"
      },
      data: {},
      buttonSearch: {
        title: "Search",
        action: this.searchTopBottom
      },
      pieChartData: null,
      testNameopts: [],
      studentData: {
        label: "assignment_overall.search_by_test_name",
        value: "",
        displayValue: "",
        fields: {
          text: "test_name_test_date",
          value: "_id"
        },
        refetchOptions: (selectedValue, queryObj) => {
          return this.getStudentOpts(selectedValue, queryObj);
        }
      }
    };
  },
  watch: {
    "studentData.value": function() {
      this.pieChartData = null;
      this.data = {};
      this.isSearching = false;
    }
  },
  methods: {
    getInfoIelts() {
      this.isSearching = true;
      const value = this.studentData.value;
      if (!value) return;
      const params = {
        test_name: value.test_name,
        test_date_w: value.test_date_final
      };
      this.searchTopBottom(this.paramsTopBottom);
      this.getIeltsPieChart(params);
      this.$nextTick(() => {
        this.$refs.componentScoreRef.getBarchartData(params);
      });
    },
    getStudentOpts(value) {
      let params = {
        test_name: value || ""
      };
      return this.$axios
        .get(
          service_names.school + `/ielts/test-name`,
          params,
          undefined,
          undefined,
          undefined,
          undefined,
          false
        )
        .then(({ data }) => {
          // get memorized selected when modal is opened
          this.testNameopts = data.slice(0, 10);
          this.testNameopts = this.testNameopts.map(student => ({
            test_name_test_date: `${
              student.test_name
            } - ${convertDateFromServer(student.test_date_final, "date")}`,
            ...student
          }));
        });
    },
    changeTopBottom(value) {
      const params = {
        order_by: value,
        page: this.paramsTopBottom.page,
        limit: this.paramsTopBottom.limit
      };
      this.searchTopBottom(params);
    },
    searchTopBottom(params) {
      this.search(params);
    },
    search(params) {
      this.$axios
        .get(`${service_names.school}/ielts/top-bottom`, {
          ...params,
          test_name: this.studentData.value.test_name,
          test_date_w: this.studentData.value.test_date_final
        })
        .then(response => {
          this.data = response.data.data;
          this.pagination.from = response.data.from;
          this.pagination.to = response.data.to;
          this.pagination.total = response.data.total;
        });
    },
    getIeltsPieChart(params) {
      this.$axios
        .get(`${service_names.school}/ielts/overall`, params)
        .then(response => {
          this.pieChartData = response.data;
        });
    }
  }
};
</script>
